import * as React from 'react';
import { memo } from 'react';

import { generateClassNameString } from 'helper/css';
import i18n from 'helper/i18n';
import noop from 'helper/noop';

import Link from 'components/atoms/Link';

export type FilterLayerPropsType = {
	handler: () => void;
	title: string;
	children: React.ReactNode;
	modifier?: string | string[];
};

export const FilterLayer = ({ handler = noop, title, children, modifier }: FilterLayerPropsType) => (
	<div className={generateClassNameString('m-filter-layer', modifier)}>
		<div className="m-filter-layer__wrapper">
			<div className="m-filter-layer__head">
				<h4 className="m-filter-layer__title">{title}</h4>
			</div>
			<div className="m-filter-layer__list">{children}</div>
			<Link
				title={i18n(`react.impulsCoach.components.filterLayer.save`)}
				onClick={() => handler()}
				modifier="button"
				iconLeft=""
				iconRight=""
				withoutIcon
			/>
		</div>
	</div>
);

export default memo(FilterLayer);
